import React from 'react'
import * as Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official'
import { HStack, Box ,Text} from '@chakra-ui/react';


const MessageDeliverd = ({datalist}) => {
    const chartvalue = datalist?.MessageDeliverdCount?.map((rs)=>{
        return {
                name: rs.status_name,
                y: Number(rs.sms_count),
                color: rs.status_name === 'Failed' ?'#EC7063' : '#45B39D'
            }
    })

    const options = {
        chart: {
            type: 'pie',
            spacing: [20, 0, 20, 0],
        },
        title: {
            text: 'Messages Delivery',
            align: 'left' // Align the title to the left
        },
        accessibility: {
            announceNewData: {
                enabled: true
            },
            point: {
                valueSuffix: '%'
            }
        },
        plotOptions: {
            pie: {
                cursor: 'pointer',                
                size: '100%',
            },
            series: {
                borderRadius: 5,
                dataLabels: [
                    {
                        enabled: true,
                        distance: 15,
                        format: '{point.name}'
                    }, 
                    {
                        enabled: true,
                        distance: '-30%',
                        filter: {
                            property: 'percentage',
                            operator: '>',
                            value: 5
                        },
                        format: '{point.y}%',
                        style: {
                            fontSize: '0.9em',
                            textOutline: 'none'
                        }
                    }
                ]
            }
        },
        tooltip: {
            headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
            pointFormat: '<span style="color:{point.color}">{point.name}</span>: <b>{point.y:.2f}%</b> of total<br/>'
        },
        series: [
            {
                name: 'Messages',
                colorByPoint: true,
                data: chartvalue,
            }
        ]
    };

    return (
        <div style={{ display: 'flex', justifyContent: 'center' ,flexDirection: 'column' }}>
            <HighchartsReact
                highcharts={Highcharts}
                options={options}
            />

            <HStack justifyContent="center">
                <Box className="chart_title_box_section">
                    <HStack>
                        <Box className="chart_title_box" bg="#EC7063"></Box>
                        <Text>Failed</Text>
                    </HStack>
                </Box>

                <Box className="chart_title_box_section">
                    <HStack>
                        <Box className="chart_title_box" bg="#45B39D"></Box>
                        <Text>Success</Text>
                    </HStack>
                </Box>
            </HStack>
        </div>
    )
}

export default MessageDeliverd;
